import {
  SortBy,
  usePotentialBookingFiltersContext,
} from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import {
  isUnsupportedLengthOfStayFilterError,
  lengthOfStayBucketsFilter,
} from '@sales-app/context/workspace/lengthOfStayBucket.util'
import { PotentialBookingQueries } from '@sales-app/graphql/queries/potentialBooking/potentialBookings.queries'
import { useDebounce } from '@shared/hooks'
import { useEffect } from 'react'

import { useGraphql } from '@/hooks/useGraphql'
import { formatDate } from '@/util'

export const usePotentialBookings = () => {
  const {
    bookablePersonType,
    potentialBookingStatuses,
    agentId,
    searchString,
    unassigned,
    moveInWithin,
    lengthOfStayBucket,
    potentialBookingIds,
    displayCity,
    sortBy,
    createdAtEndDate,
    createdAtStartDate,
    setFilters,
  } = usePotentialBookingFiltersContext()
  const debouncedSearch = useDebounce(searchString, 1000)
  const createdAt =
    createdAtStartDate && createdAtEndDate
      ? {
          start: formatDate(createdAtStartDate, 'yyyy-MM-dd'),
          end: formatDate(createdAtEndDate, 'yyyy-MM-dd'),
        }
      : createdAtStartDate
        ? {
            start: formatDate(createdAtStartDate, 'yyyy-MM-dd'),
            end: formatDate(createdAtStartDate, 'yyyy-MM-dd'),
          }
        : undefined

  const potentialBookingQuery = useGraphql<PotentialBookingQueries.GET_POTENTIAL_BOOKINGS.Response>(
    PotentialBookingQueries.getPotentialBookings.name,
    PotentialBookingQueries.getPotentialBookings(),
    {
      filter: {
        bookablePersonType,
        potentialBookingStatuses,
        agentIds: agentId ? [agentId] : null,
        searchString: debouncedSearch,
        unassigned,
        moveInWithin,
        ...lengthOfStayBucketsFilter(lengthOfStayBucket),
        potentialBookingIds,
        displayCityIds: displayCity ? [displayCity.id] : null,
        createdAt,
      },
      sortBy: sortBy
        ? {
            field: getSortByField(sortBy),
            direction: sortBy.desc ? 'Descending' : 'Ascending',
          }
        : null,
    },
    { refetchOnMount: 'always' },
  )

  // If the backend doesn't support the length-of-stay filter yet, drop the saved bucket so the list loads again
  // instead of staying empty across reloads.
  const { error } = potentialBookingQuery
  useEffect(() => {
    if (lengthOfStayBucket && isUnsupportedLengthOfStayFilterError(error)) {
      setFilters({ lengthOfStayBucket: null })
    }
  }, [error, lengthOfStayBucket, setFilters])

  return potentialBookingQuery
}

function getSortByField(sortBy: SortBy) {
  let field = 'PotentialBookingMoveInDate'
  if (sortBy.id === 'createdAt') {
    field = 'PotentialBookingCreatedAt'
  } else if (sortBy.id === 'moveIn') {
    field = 'PotentialBookingMoveInDate'
  }
  return field
}
